
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";
import { AppointmentFormData, AppointmentResult } from "./types";

export async function createAppointment(appointmentData: AppointmentFormData): Promise<AppointmentResult> {
  try {
    console.log("Iniciando criação do compromisso:", appointmentData);
    
    const { data: user } = await supabase.auth.getUser();
    if (!user?.user) {
      console.error("Usuário não autenticado");
      return { 
        success: false, 
        error: { message: "Usuário não autenticado" } 
      };
    }
    
    const { data, error } = await supabase.from("appointments").insert({
      title: appointmentData.title,
      type: appointmentData.type,
      date: appointmentData.date.toISOString(),
      end_date: appointmentData.end_date?.toISOString() || null,
      location: appointmentData.location,
      notes: appointmentData.notes,
      client_id: appointmentData.client_id,
      user_id: user.user.id,
      archived: false,
    }).select();

    if (error) {
      console.error("Erro ao cadastrar compromisso:", error);
      toast({
        title: "Erro ao cadastrar compromisso",
        description: error.message,
        variant: "destructive",
      });
      return { success: false, error };
    }

    console.log("Compromisso criado com sucesso:", data);
    toast({
      title: "Compromisso cadastrado com sucesso!",
      description: "O compromisso foi adicionado à sua agenda.",
    });
    return { success: true, data };
  } catch (error: any) {
    console.error("Exceção ao cadastrar compromisso:", error);
    toast({
      title: "Erro ao cadastrar compromisso",
      description: error.message,
      variant: "destructive",
    });
    return { success: false, error };
  }
}
